// @ts-nocheck
import { chain, GetShipTos } from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadCurrentShipTos";
import translate from "@insite/client-framework/Translate";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";
import constants from "@store/constants";
import { addToChainAfter, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const SetNewOptions = createChainHandler("SetNewOptions", chain, props => {
    const state = props.getState();

    if (props.apiResult.shipTos) {
        const newShipTosOptions = props.apiResult?.shipTos.reduce((shipTos: ShipToModel[], shipTo: ShipToModel) => {
            let _shipTo = shipTo;
            if (shipTo.id === constants.shipTosOptions.showAll) {
                _shipTo = { ..._shipTo, label: translate("Show All Ship-Tos") };
            }

            if (shipTo.id === state.context.session.shipToId) {
                _shipTo = { ..._shipTo, label: `[${translate("CURRENT")}] ${shipTo.label}` };
            }

            return shipTos.concat(_shipTo);
        }, []);

        if (props.apiResult?.shipTos.length > 2) {
            const showMyShipTos: ShipToModel = {
                address1: "",
                address2: "",
                address3: "",
                address4: "",
                attention: "",
                city: "",
                companyName: "",
                contactFullName: "",
                country: null,
                customerName: "",
                customerNumber: "",
                customerSequence: newShipTosOptions
                    .filter(x => x.customerSequence !== "-1")
                    .map(x => x.customerSequence)
                    .join(","),
                email: "",
                fax: "",
                firstName: "",
                fullAddress: "",
                id: "Show My Ship-Tos",
                isDefault: false,
                isNew: false,
                isVmiLocation: false,
                label: translate("Show My Ship-Tos"),
                lastName: "",
                oneTimeAddress: false,
                phone: "",
                postalCode: "",
                state: null,
                validation: null,
                properties: {},
                uri: "",
            };
            newShipTosOptions.splice(1, 0, showMyShipTos);
        }

        props.apiResult.shipTos = newShipTosOptions;
    }
});

addToChainAfter(chain, GetShipTos, SetNewOptions);
